module.exports = __webpack_public_path__ + "res/img/lt.902b764f.png";